import { logEvent } from "@src/appV2/lib/analytics/log";
import { APP_V2_USER_EVENTS } from "@src/appV2/lib/analytics/events";
import { type TimeSlotWithExtras } from "@src/appV2/Shifts/types";

interface LogShiftTimeEditSavedParams {
  workplaceId: string;
  workplaceUserId?: string;
  timeSlot: TimeSlotWithExtras;
  qualification?: string;
  /** Scope the edit applied to; a plain string since callers use different scope vocabularies. */
  applyTo: string;
  shiftId?: string;
}

/**
 * Fires the shift-time-edit "saved" event from every surface that edits shift
 * times with an apply-to scope (shift card pencil, invite side panel,
 * single-shift posting form, bulk posting). Centralized here so the payload
 * shape stays consistent regardless of which flow triggered the save.
 */
export function logShiftTimeEditSaved(params: LogShiftTimeEditSavedParams): void {
  const { workplaceId, workplaceUserId, timeSlot, qualification, applyTo, shiftId } = params;

  logEvent(APP_V2_USER_EVENTS.SCHEDULE_SHIFT_TIME_EDIT_SAVED, {
    workplaceId,
    workplaceUserId,
    timeSlot,
    qualification,
    applyTo,
    ...(shiftId && { shiftId }),
  });
}
